/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

export const facetNavigationFacetEntryFormControlLabelSX: SxProps = {
	width: ['100%', 'auto', '100%'],
	'& .MuiFormControlLabel-label': {
		width: '100%'
	}
};

export const facetNavigationFacetEntrySwatchSX: SxProps = {
	mb: 1,
	mr: 1,
};
